import { Attachment } from '@modusign/react-signing/types';

export function getFormattedFilename(file: Attachment['file']) {
  if (!file?.name || !file?.extension) {
    return null;
  }
  return `${file.name}${file.extension}`;
}
